<template>
  <v-dialog v-model="dialogComputed" max-width="1000px" scrollable>
    <v-card v-if="dialogComputed">
      <v-card-title class="primary white--text py-2">
        {{ $t('ELE0164') }}
        <v-spacer />
        <Btn icon="mdi-close" @click="onClickClose" depressed iconProp color="white" />
      </v-card-title>
      <v-card-text class="py-0">
        <v-container fluid>
          <v-row>
            <v-col cols="3">
              <TextFieldRef :label="$t('ELE0137')" :value="inspIndexNo" />
            </v-col>
            <v-col cols="3">
              <TextFieldRef :label="$t('ELE0157')" :value="cav" />
            </v-col>
            <v-col cols="3">
              <TextFieldRef :label="$t('ELE0098')" :value="numOfInsp" right />
            </v-col>
          </v-row>
          <v-card outlined>
            <v-card-title>
              {{ $t('ELE0023') }}
            </v-card-title>
            <v-card-text>
              <v-data-table :headers="headers" :items="boxes" dense> </v-data-table>
            </v-card-text>
          </v-card>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Btn from '@/components/atoms/base/button/Btn'
import TextFieldRef from '@/components/atoms/base/text-field/TextFieldRef'

export default {
  name: 'SearchBoxSamplingDialog',

  components: {
    Btn,
    TextFieldRef,
  },

  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    inspIndexNo: {
      type: String,
      required: true,
    },
    cav: {
      type: String,
      required: false,
      default: '',
    },
    numOfInsp: {
      type: Number,
      required: false,
      default: null,
    },
    boxes: {
      type: Array,
      required: false,
      default: () => [],
    },
  },

  computed: {
    dialogComputed: {
      get() {
        return this.dialog
      },
      set(value) {
        this.$emit('update:dialog', value)
      },
    },
  },

  data() {
    return {
      headers: [{ text: this.$t('ELE0056'), value: 'refNo' }],
    }
  },

  methods: {
    onClickClose() {
      this.dialogComputed = false
    },
  },
}
</script>
